var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33334 0.975749C4.33334 0.676594 4.57586 0.434082 4.87501 0.434082H12.4583C12.7575 0.434082 13 0.676594 13 0.975749C13 1.2749 12.7575 1.51742 12.4583 1.51742H4.87501C4.57586 1.51742 4.33334 1.2749 4.33334 0.975749ZM0 4.1546C0 3.85545 0.242512 3.61293 0.541667 3.61293H12.4583C12.7575 3.61293 13 3.85545 13 4.1546C13 4.45375 12.7575 4.69627 12.4583 4.69627H0.541667C0.242512 4.69627 0 4.45375 0 4.1546ZM4.87501 6.792C4.57586 6.792 4.33334 7.03451 4.33334 7.33367C4.33334 7.63282 4.57586 7.87533 4.87501 7.87533H12.4583C12.7575 7.87533 13 7.63282 13 7.33367C13 7.03451 12.7575 6.792 12.4583 6.792H4.87501Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearMinimize);
export default __webpack_public_path__ + "static/media/near-minimize.90664d39.svg";
export { ForwardRef as ReactComponent };